export default __webpack_public_path__ + "static/media/smartContract.f1f91e13.svg";